import React, { FC, ReactElement } from 'react'

// OKX marketplace mark: a 3x3 grid with the corners and centre filled. The
// brand is black-and-white, so every square uses currentColor and the
// consumer decides the colour (`text-foreground` inverts with the theme).
const OkxIcon: FC<{ className?: string }> = ({ className }): ReactElement => {
	return (
		<svg
			className={className}
			viewBox="0 0 30 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<rect x="0" y="0" width="10" height="10" fill="currentColor" />
			<rect x="20" y="0" width="10" height="10" fill="currentColor" />
			<rect x="10" y="10" width="10" height="10" fill="currentColor" />
			<rect x="0" y="20" width="10" height="10" fill="currentColor" />
			<rect x="20" y="20" width="10" height="10" fill="currentColor" />
		</svg>
	)
}

export default OkxIcon
